import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Period } from "@rossum/upcloud-costs-shared";

import { formatMonth } from "../../common/format";

interface MonthSelectProps {
    label: string;
    value: string;
    periods: readonly Period[];
    onChange: (month: string) => void;
}

/** Selects one of the months with billing data. */
export function MonthSelect({ label, value, periods, onChange }: MonthSelectProps) {
    const { i18n } = useTranslation();
    const id = `month-${label}`;
    return (
        <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel id={id}>{label}</InputLabel>
            <Select
                labelId={id}
                label={label}
                value={value}
                onChange={(event) => {
                    onChange(event.target.value);
                }}>
                {periods.map((period) => (
                    <MenuItem key={period.month} value={period.month}>
                        {formatMonth(period.month, i18n.language)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
